import FaqTag from './FaqTag.component';

export default FaqTag;
